export default {
  showMoreStyle: {
    alignItems: 'center',
    gap: 8
  },
  tagsRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8
  }
}
